import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TAllFiltersModal } from 'shared/types/allFiltersModal';

export const allFiltersModalSlice = createSlice({
  name: 'allFiltersModal',
  initialState: { isOpen: false } as TAllFiltersModal,
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
  },
});

export const {
  reducer: allFiltersModalReducer,
  name: allFiltersModalReducerName,
  actions: { setModalOpen },
} = allFiltersModalSlice;
